import { render, staticRenderFns } from "./history-tab.vue?vue&type=template&id=63d34bbd&scoped=true"
import script from "./history-tab.vue?vue&type=script&lang=js"
export * from "./history-tab.vue?vue&type=script&lang=js"
import style0 from "./history-tab.vue?vue&type=style&index=0&id=63d34bbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d34bbd",
  null
  
)

export default component.exports